module.exports = __webpack_public_path__ + "static/partner-2-988de3357dbbb52694d1a609b6ec1b92.png";